"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.paletteRose = void 0;
exports.paletteRose = {
    black: {
        main: '#060201',
        hover: 'rgba(0,0,0,0.04)',
        focus: 'rgba(0,0,0,0.12)',
        pressed: 'rgba(0,0,0,0.1)',
        dragged: 'rgba(0,0,0,0.08)',
        selected: 'rgba(0,0,0,0.08)',
    },
    white: {
        main: '#FFFFFF',
        hover: 'rgba(255,255,255,0.04)',
        focus: 'rgba(255,255,255,0.12)',
        pressed: 'rgba(255,255,255,0.1)',
        dragged: 'rgba(255,255,255,0.08)',
        selected: 'rgba(255,255,255,0.08)',
    },
    iris_light: {
        main: 'rgba(167, 99, 91, 0.08)',
        hover: 'rgba(167, 99, 91, 0.04)',
        focus: 'rgba(167, 99, 91, 0.12)',
        pressed: 'rgba(167, 99, 91, 0.1)',
        dragged: 'rgba(167, 99, 91, 0.08)',
        selected: 'rgba(167, 99, 91, 0.08)',
        text: '#a7635b',
    },
    iris: {
        main: '#a7635b',
        hover: '#a7635b0a',
        focus: '#a7635b1f',
        pressed: '#a7635b1a',
        dragged: '#a7635b14',
        selected: '#a7635b14',
        light: '#a7635b',
        lighter: '#cf2d9e',
    },
    destructive: {
        main: '#FCEDEC',
        hover: '#FEF7F6',
        focus: '#FBE4E3',
        pressed: '#FCE8E8',
        text: '#DF1D17',
    },
    fuchsia: {
        main: '#EF5DA8',
    },
    success: {
        main: '#22A958',
        transparent: '#22A9581A',
    },
    caution: {
        main: '#FFC21C',
        transparent: '#FFC21C1A',
    },
    circular: {
        main: 'rgba(167, 99, 91, 0.12)',
    },
    danger: {
        main: '#DF1D17',
        transparent: '#DF1D171A',
    },
    dim: {
        main: '#EBECF2',
        transparent: '#EBECF233',
    },
    onSurfaceColors: {
        highEmphasis: '#1A1C23',
        mediumEmphasis: '#616475',
        disabled: '#9B9EAB',
    },
    onColorColors: {
        highEmphasis: '#F5F5F5',
        mediumEmphasis: 'rgba(255,255,255,0.74)',
        disabled: 'rgba(255,255,255,0.38)',
    },
    pending: {
        main: '#EE7300',
        transparent: '#EE73001A',
    },
    partial: {
        main: '#8BC34A',
        transparent: 'rgba(139, 195, 74, 0.1)',
    },
    grey: {
        main: '#F3F3F3',
    },
    dynamicColors: {
        purple: '#F9F1FF',
        yellow: '#FAF9EB',
        blue: '#EBF9FA',
        green: '#EBFAEC',
    },
};
